import React, { useEffect, useContext,useState } from 'react';
import { useTranslation } from 'react-i18next'
import { RiClipboardLine } from 'react-icons/ri'
import { SmartContext } from 'stores/SmartStore'
import { useHistory, useParams } from 'react-router-dom'
import { FlexView, Link, Card, Table, Icon, Spinner } from 'components/common'
import {BackButtons,SpanPageTitle,SpanItem,SpanTitle,SmallText,ModalContainer,FlexSpaceBetween} from './styles'
import Modal from 'components/common/Modal';
// import tableData from './mocks.json'


export function DataManagementResults() {
  const { t } = useTranslation()
  const history = useHistory()
  const {searchDataManagement,data,isLoading} = useContext(SmartContext)
  const [showModal, setShowModal] = useState(false)
  const [modalData, setModalData] = useState([])
  let { sellOrders } = useParams()
  const goTo = (value) => () => {
    history.push("/ippn/" + value)
  }
  const columnsProdNotOk =[
    {
      Header: 'Production NOK',
      accessor: (row) =><Link onClick={()=> console.log('doaction')}> {row !== null ? row : 'not found'}</Link>
    }
  ]
  const columnsGeometryNotOk =[
    {
      Header: 'Geometry NOK',
      accessor: (row) =><Link onClick={()=> console.log('doaction')}> {row.ippn !== null ? row.ippn : 'not found'}</Link>
    }
  ]
  const columns = [
    {
      Header: 'Ordem de Venda',
      accessor: (row) => <Link onClick={()=> console.log('doaction')}> {row.sell_order}</Link>,
      id: 'sell_order'
    },
    {
      Header: 'Descrição',
      accessor: (row) => <Link onClick={()=> console.log('doaction')}> {row.description}</Link>,
      id: 'description',
    },
    // {
    //   Header: 'Billing Date',
    //   accessor: (row)=>(row.manufactureDate ? row.manufactureDate :'-'),
    //   id: 'manufactureDate',
    // },    
    // {
    //   Header: 'Purchase Order',
    //   accessor: 'purchase_order',
    //   id: 'purchase_order',
    // },
    {
      Header: 'Peças',
      accessor: 'pieces',
      id: 'pieces',
    },
    {
      Header: 'Dados de fabricação',
      accessor: (row) =>  {return(
      <FlexSpaceBetween>
        <SmallText  isOk>OK-{row.production_ok.length}</SmallText>
        <Link onClick={()=>handleOpenModal(row)}>
          <SmallText isNok>NOK-{row.production_nok.length}</SmallText>
        </Link>
      </FlexSpaceBetween>
      )} ,
      id: 'production_status',
    },
    {
      Header: 'Dados de geometria',
      accessor: (row) =>  {return(
      <FlexSpaceBetween>
        <SmallText isOk>OK-{row.geometry_ok.length}      </SmallText>
        <Link onClick={()=>handleOpenModal(row)}>
         <SmallText isNok>NOK-{row.geometry_nok.length}</SmallText>
        </Link>
      </FlexSpaceBetween>
      )} ,
      id: 'geometry_status',
    },
  ]
 async function handleSellOrdersParam(id) {
    let ordem =[]
    let completeSellOrder=[]
    id.split(',').map(item => {
      completeSellOrder.push(item)
    })
    completeSellOrder.map(item => {
      ordem.push({num_sell_order:item.split('-')[0],item:item.split('-')[1]})
    })
    await searchDataManagement(ordem)
  }

  function handleOpenModal(row) {
    console.log('row',row)
    setShowModal(!showModal)
    setModalData(row)
  }

  
  useEffect(() => {
    handleSellOrdersParam(sellOrders)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history])
  return(
    
    <FlexView flexDirection="column" alignSelf="stretch" padding="10px 40px">
      <FlexView flexDirection='row' alignSelf="stretch" >
        <BackButtons outline color="#f4f4f4">
          <Icon tooltip="Left" tooltipPosition="left" name="arrow-left" width="15px" height="15px" onClick={()=> console.log('backbutton')} />
        </BackButtons>
        <SpanPageTitle>
          {t('data-management.sell-orders')}:
        </SpanPageTitle>
        <SpanItem>
          {sellOrders.length < 5 ? sellOrders : sellOrders.substring(0,55) + '....'}
        </SpanItem>
        
      </FlexView>
      {isLoading ?
      <FlexView flexDirection="column" alignSelf="center" padding="10px 40px">
        <Spinner/>
      </FlexView> 
                    : 
      <FlexView flexDirection="column" alignSelf="center" padding="10px 40px">

      <Card
          borderRadius="8px"
          flexDirection='column'
          fontSize="medium"
          alignSelf="stretch"
          alignItems="stretch"
        >
          {data.materialData &&
          <> 
          <Card
              borderRadius="8px"
              flexDirection='column'
              fontSize="medium"
              alignSelf="stretch"
              alignItems="stretch"
            >
              <SpanTitle>
                <RiClipboardLine style={{ margin: '0px 8px 0px 4px', color: '#777777' }} /> DADOS:  </SpanTitle>
                <Table columns={columns} data={data.materialData} sortable elevation="none" borderRadius="card" paginated style={{ whiteSpace: 'nowrap' }} />
          </Card>
          
            <Modal isOpen={showModal} onModalExit={()=>setShowModal(false)}>
            <ModalContainer >
              
              {modalData.production_nok && modalData.production_nok.length > 0 && 
                <Table columns={columnsProdNotOk} data={modalData.production_nok} sortable elevation="none" borderRadius="card" paginated style={{ whiteSpace: 'nowrap' }} />
              }
              {modalData.geometry_nok && modalData.geometry_nok.length>0 &&
                <Table columns={columnsGeometryNotOk} data={modalData.geometry_nok} sortable elevation="1" borderRadius="card" paginated style={{ whiteSpace: 'nowrap' }} />
              }
              </ModalContainer>
            </Modal>
          </>
          }
          </Card>
      
      </FlexView>}
    </FlexView>
    )
}